import React, { Fragment, useCallback, useEffect, useState } from 'react'
import MenuMarketplace from '../../components/menus/MenuMarketplace'
import { Alert, Button, Card, Col, Container, Form, FormSelect, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { getClient } from '../../actions/profiles/clientsActions'
import Loader from '../../components/design/Loader/Loader'
import { getPaymentStatus, payItems, startPublicPurchase, startPurchase } from '../../actions/payments/paymentActions'
import Swal from 'sweetalert2'
import { resetCart } from '../../actions/payments/cartActions'
import { useNavigate } from 'react-router'
import { FooterMarketplace } from '../../components/footers/FooterMarketplace'
import CheckOutActivity from '../../components/Activities/CheckOutActivity'
import CheckOutPassType from '../../components/ticketing/CheckOutPassType'
import CheckOutTicket from '../../components/ticketing/CheckOutTicket'
import CheckOutReservation from '../../components/ticketing/CheckOutReservation'
import { cancelReservation } from '../../actions/sites/reservationsActions'
import { getTicketsByClient } from '../../actions/ticketing/ticketsActions'

export default function CheckOut() {
	const {clientauth} = useAuth()
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [policy, setPolicy] = useState(false)
    const [policyMinors, setPolicyMinors] = useState(false)
    const [policySendMarket, setPolicySendMarket] = useState(false)

    const { items } = useSelector(state => state.cart)
    const { client } = useSelector(state => state.clients)
    const { loading, error, paymentData, paymentStatus, itemsPayment, publicPurchaseData } = useSelector(state => state.payment)

    // const [total, setTotal] = useState(null)
    const [totalToPay, setTotalToPay] = useState(null)
    const [totalSaved, setTotalSaved] = useState(null)

    // If any group requires verification
    // const [needVerification, setNeedVerification] = useState(false)

    const [waitingForPayment, setWaitingForPayment] = useState(false)

    const [isPaying, setIsPaying] = useState(false)

    const [selectedCard, setSelectedCard] = useState(null)
    const [gatewayPaymentResult, setGatewayPaymentResult] = useState(null)

    const [paymentPersonData, setPaymentPersonData] = useState({
        firstname: null,
        lastname: null,
        email: null
    })

    useEffect(() => {
        // Reutilizar los datos del primer item del carrito si están disponibles
        if (items && items.length > 0) {
            const firstItem = items[0]
            if (firstItem.ticket) {
                setPaymentPersonData({
                    firstname: firstItem.ticket.firstname || firstItem.ticket.client?.firstname,
                    lastname: firstItem.ticket.lastname || firstItem.ticket.client?.lastname,
                    email: firstItem.ticket.email || firstItem.ticket.client?.email
                })
            }
        }
    }, [items])

    const handlePayClick = () => {
        if (client) {
            if (!client?.cards || client?.cards?.length === 0) {
                dispatch(startPurchase({
                    quantity: 0,
                    paymentClient: client?._id,
                    product: t('client.newCardDescription'),
                }))
            }
        }
        setIsPaying(true)
    }

    const handlePaymentLinkClick = (e) => {
        e.preventDefault(); // Prevenir que el enlace abra la ventana
        
        setWaitingForPayment(true)
        window.checkOutPaymentStatusIntervalIndex = 0

        const intervalFn = async () => {
            clearInterval(window.checkOutPaymentStatusInterval)
            setWaitingForPayment(false)
            setIsPaying(false)
            
            // Cancelar las reservas pendientes
            for (const item of items) {
                if (item.court) {
                    console.log('Verificando estado del pago antes de cancelar:', {
                        paymentId: client ? paymentData?.payment?._id : publicPurchaseData?.payment?._id,
                        paymentStatus: paymentStatus
                    });

                    // Última comprobación del estado del pago
                    try {
                        const paymentResponse = await fetch(`${process.env.REACT_APP_DB_ADDRESS}/api/payment/getPaymentStatus/${client ? paymentData?.payment?._id : publicPurchaseData?.payment?._id}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });

                        if (paymentResponse.ok) {
                            const paymentData = await paymentResponse.json();
                            console.log('Estado final del pago:', paymentData);
                            
                            // Si el pago es exitoso, no cancelar
                            if (paymentData.status === 3) {
                                console.log('Pago exitoso detectado, no se cancela la reserva');
                                return;
                            }
                        }
                    } catch (error) {
                        console.error('Error al verificar estado final del pago:', error);
                    }

                    console.log('Procediendo a cancelar la reserva:', {
                        personData: item.personData,
                        court: item.court,
                        date: item.date,
                        slots: item.slots
                    });

                    try {
                        const response = await fetch(`${process.env.REACT_APP_DB_ADDRESS}/api/reservation/public/getreservationpublicbycourtanddate?court=${item.court._id}&date=${new Date(item.date).toLocaleDateString('sv-SE')}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });

                        if (!response.ok) {
                            throw new Error('Error al obtener la reserva');
                        }

                        const data = await response.json();
                        console.log('Respuesta de la API:', data);

                        const reservations = Array.isArray(data) ? data : data.reservations || [];
                        console.log('Reservas encontradas:', reservations);

                        const reservation = reservations.find(r => 
                            r.startHour === item.slots[0].startHour && 
                            r.endHour === item.slots[item.slots.length - 1].endHour
                        );

                        if (reservation) {
                            console.log('Reserva encontrada, procediendo a cancelar:', reservation);
                            // Generar token temporal para cancelación
                            const tempToken = btoa(JSON.stringify({
                                reservationId: reservation._id,
                                timestamp: new Date().getTime(),
                                action: 'cancel'
                            }));
                            sessionStorage.setItem('temp_cancel_token', tempToken);
                            console.log('Token temporal generado:', tempToken);
                            await dispatch(cancelReservation(reservation._id, false));
                        } else {
                            console.log('No se encontró la reserva correspondiente:', {
                                court: item.court._id,
                                date: new Date(item.date).toLocaleDateString('sv-SE'),
                                slots: item.slots
                            });
                        }
                    } catch (error) {
                        console.error('Error al cancelar la reserva:', error);
                    }
                }
            }
            
            dispatch({ type: 'PAYMENT_PAYMENT_STATUS_RESET' })
        }

        window.checkOutPaymentStatusInterval = setInterval(() => {
            window.checkOutPaymentStatusIntervalIndex++
            dispatch(getPaymentStatus(client ? paymentData?.payment?._id : publicPurchaseData?.payment?._id))
            
            if (window.checkOutPaymentStatusIntervalIndex > 600) {
                intervalFn()
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: t('Has superado el tiempo de espera, por favor, realice de nuevo la reserva')
                })
            }
        }, 1000)

        // Abrir la ventana de Paycomet y controlar su cierre
        const paymentWindow = window.open(client ? paymentData?.challengeUrl : publicPurchaseData?.challengeUrl, '_blank')
        const checkWindow = setInterval(() => {
            if (paymentWindow.closed) {
                clearInterval(checkWindow)
            }
        }, 1000)
    }

    useEffect(() => {
        const onPaymentResultMessage = ({ data, origin }) => {
            if (origin !== window.location.origin) return
            if (!data || data.type !== 'CARD_PAYMENT_RESULT') return
            setGatewayPaymentResult(data.status)
        }

        window.addEventListener('message', onPaymentResultMessage)

        return () => {
            window.removeEventListener('message', onPaymentResultMessage)
        }
    }, [])

    const handlePaymentFailure = useCallback(async () => {
        clearInterval(window.checkOutPaymentStatusInterval)
        setWaitingForPayment(false)
        setIsPaying(false)

        // Pago fallido - cancelar reservas
        for (const item of items) {
            if (item.court) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_DB_ADDRESS}/api/reservation/public/getreservationpublicbycourtanddate?court=${item.court._id}&date=${new Date(item.date).toLocaleDateString('sv-SE')}`, {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    });
                    if (response.ok) {
                        const data = await response.json();
                        const reservations = Array.isArray(data) ? data : data.reservations || [];
                        const reservation = reservations.find(r =>
                            r.startHour === item.slots[0].startHour &&
                            r.endHour === item.slots[item.slots.length - 1].endHour
                        );
                        if (reservation) {
                            const tempToken = btoa(JSON.stringify({ reservationId: reservation._id, timestamp: new Date().getTime(), action: 'cancel' }));
                            sessionStorage.setItem('temp_cancel_token', tempToken);
                            await dispatch(cancelReservation(reservation._id, false));
                        }
                    }
                } catch (error) {
                    console.error('Error al cancelar la reserva:', error);
                }
            }
        }
        Swal.fire({
            showConfirmButton: true,
            icon: 'error',
            text: t('cart.paymentFailedRetry', 'El pago ha fallado. Por favor, repita la operacion.')
        });
        dispatch({ type: 'PAYMENT_PAYMENT_STATUS_RESET' });
    }, [dispatch, items, t])

    useEffect(() => {
        if (!gatewayPaymentResult) return

        const currentPaymentId = client ? paymentData?.payment?._id : publicPurchaseData?.payment?._id

        if (gatewayPaymentResult === 'success' && currentPaymentId) {
            // Trigger an immediate refresh after gateway success; final decision remains backend status.
            dispatch(getPaymentStatus(currentPaymentId))
        }

        if (gatewayPaymentResult === 'error') {
            handlePaymentFailure()
        }

        setGatewayPaymentResult(null)
    }, [gatewayPaymentResult, client, paymentData, publicPurchaseData, dispatch, t, handlePaymentFailure])

    const saveCart = () => {
        dispatch(payItems({items, card: selectedCard, paymentClient: clientauth?.client, policy: policy, minorsPolicy: policyMinors, sendMarketPolicy: policySendMarket}))
    }

    const handlePaymentPersonDataChange = ({target}) => {
        setPaymentPersonData({
            ...paymentPersonData,
            [target.name]: target.value
        })
    }

    const handleStartPurchase = () => {
        if (!paymentPersonData.firstname || paymentPersonData.firstname === "" || !paymentPersonData.lastname || paymentPersonData.lastname === "" || !paymentPersonData.email || paymentPersonData.email === "") {
            Swal.fire({
                icon: 'error',
                text: t('cart.paymentPersonData.noFields'),
                showConfirmButton: true,
                confirmButtonText: t('global.accept'),
                timer: 2000
            })
        } else {
            dispatch(startPublicPurchase({items, paymentPersonData: paymentPersonData, policy: policy, minorsPolicy: policyMinors, sendMarketPolicy: policySendMarket}))
        }
    }

    useEffect(() => {
        // let acumulated = 0
        let acumulatedToPay = 0
        let totalSaved = 0

        for (const item of items) {
            if (item.activity) {
                let priceToPay = 0
                let saved = 0
                let isInRangeToEnroll = false
                const currentDate = new Date()
    
                let registrationPayment = 0
                if (item.group.registrationPayment?.maxdate && new Date(item.group.registrationPayment?.maxdate) >= currentDate) {
                    registrationPayment = parseFloat(item.group.registrationPayment.price)
                }
                const registrationImpact = item.questions
                .reduce((sum, question) => {
                    const registrationPercentageTotal = (parseFloat(registrationPayment) * ((parseFloat(question?.impact?.registrationPercentage || 0)) / 100))
    
                    return parseFloat(sum) + (parseFloat(registrationPercentageTotal)) + (question?.impact?.registrationQuantity || 0);
                }, 0)
    
                if (item.promotions) {
                    let registrationTotal = parseFloat(registrationPayment) + parseFloat(registrationImpact)
                    for (const promotion of item.promotions) {
                        if (registrationTotal > 0) {
                            const promotionPercentageTotal = (parseFloat(registrationTotal) * ((parseFloat(promotion.impact.registrationPercentage || 0)) / 100))
                            registrationTotal -= (parseFloat(promotionPercentageTotal)) + (promotion.impact.registrationQuantity || 0)
                        } else {
                            registrationTotal = 0
                        }
                    }
    
                    if (registrationTotal < 0) {
                        registrationTotal = 0
                    }
    
                    saved += (parseFloat(registrationPayment) + parseFloat(registrationImpact)) - registrationTotal
                }
    
                const seasonPaymentsTotal = item.group.seasonPayments.reduce((seasonPaymentTotal, seasonPayment) => {
                    if (new Date(seasonPayment.startDate) <= currentDate && new Date(seasonPayment.endDate) >= currentDate) {
                        isInRangeToEnroll = true
                        const seasonPaymentImpact = item.questions
                        .reduce((questionTotal, question) => {
                            const seasonPaymentPercentageTotal = (parseFloat(seasonPayment.price) * ((parseFloat(question?.impact?.seasonPaymentPercentage || 0)) / 100))
            
                            return parseFloat(questionTotal) + (parseFloat(seasonPaymentPercentageTotal)) + (question?.impact?.seasonPaymentQuantity || 0);
                        }, 0)
    
                        let total = parseFloat(seasonPayment.price) + parseFloat(seasonPaymentImpact)
    
                        if (item.promotions) {
                            for (const promotion of item.promotions) {
                                if (total > 0) {
                                    const promotionPercentageTotal = (parseFloat(total) * ((parseFloat(promotion.impact.seasonPaymentPercentage || 0)) / 100))
                                    total -= (parseFloat(promotionPercentageTotal)) + parseFloat(promotion.impact.seasonPaymentQuantity || 0)
                                } else {
                                    total = 0
                                }
                            }
    
                            if (total < 0) {
                                total = 0
                            }
                        }
    
                        saved += (parseFloat(seasonPayment.price) + parseFloat(seasonPaymentImpact)) - total
                        return parseFloat(seasonPaymentTotal) + (parseFloat(seasonPayment.price) + parseFloat(seasonPaymentImpact) <= 0 ? 0 : parseFloat(seasonPayment.price) + parseFloat(seasonPaymentImpact))
                    } else {
                        if (currentDate < new Date(seasonPayment.endDate)) {
                            isInRangeToEnroll = true
                        }
                        return seasonPaymentTotal
                    }
                }, 0)
    
                priceToPay = (parseFloat(registrationPayment) + parseFloat(registrationImpact) + parseFloat(seasonPaymentsTotal)) - saved
    
                const priceComission = item.commission?.find(activity => priceToPay >= activity.lowPrice && priceToPay <= activity.highPrice);
    
                // acumulated += Math.ceil((parseFloat(priceToPay) + parseFloat(priceToPay * parseFloat(priceComission?.percentage) / 100) + parseFloat(priceComission?.double)) * 100) / 100
    
                if (!item.group.verify && isInRangeToEnroll) {
                    if(!item.waitinglist){
                        if (priceToPay > 0) {
                            acumulatedToPay += Math.ceil((parseFloat(priceToPay) + parseFloat(priceToPay * (priceComission?.percentage || 0) / 100) + parseFloat(priceComission?.double || 0)) * 100) / 100
                        }
                    }
                }
                totalSaved += parseFloat(saved)
            }
            if (item.passType) {
                let priceToPay = item.passType.seasons?.find(season => season.season?._id === item.season)?.price || 0
    
                // Añadir precio del pase físico si está seleccionado (solo por los abonos que se van a comprar)
                const physicalPassPrice = item.physicalPass ? (item.passType?.physicalPassPrice * item.passes?.length || 0) : 0
                const totalBasePrice = priceToPay + physicalPassPrice
                console.log(physicalPassPrice)

                if (totalBasePrice > 0) {
                    const priceComission = item.commission?.find(activity => totalBasePrice >= activity.lowPrice && totalBasePrice <= activity.highPrice);
                    acumulatedToPay += Math.ceil((parseFloat(totalBasePrice) + parseFloat(totalBasePrice * (priceComission?.percentage || 0) / 100) + parseFloat(priceComission?.double || 0)) * 100) / 100
                }
            }
            if (item.match) {
                let priceToPay = 0

                if (item.ticket?.type === "pass") {
                    priceToPay = item.match.passTypes?.find(p => p.passType === item.ticket.client?.passType)?.price || 0
                } else if (item.ticket?.type === "passDiscount") {
                    priceToPay = Number(item.ticket?.discount?.rawPrice || 0)
                } else {
                    priceToPay = item.match.sectors?.find(s => s.sector === item.ticket.sector._id)?.fees?.find(f => f.fee === item.ticket.fee._id)?.price || 0
                }

                priceToPay += Number(item.ticket?.addon?.shirtRawPrice || 0)

                if (priceToPay > 0) {
                    const priceComission = item.commission?.find(activity => priceToPay >= activity.lowPrice && priceToPay <= activity.highPrice);
                    acumulatedToPay += Math.ceil((parseFloat(priceToPay) + parseFloat(priceToPay * (priceComission?.percentage || 0) / 100) + parseFloat(priceComission?.double || 0)) * 100) / 100
                }
            }
            if (item.court) {
                if (item.slots && item.slots.length > 0) {
                    for (const value of item.slots) {
                        let price = value?.price
                        if (price > 0) {
                            const sitesCommission = item.commission?.find(site => price >= site.lowPrice && price <= site.highPrice);
                            const commissionAmount = sitesCommission ? Math.ceil((price * (sitesCommission.percentage/100) + sitesCommission.double) * 100) / 100 : 0;
                            const totalPrice = price + commissionAmount;
                            acumulatedToPay += Math.round(totalPrice * 100) / 100;
                        }
                    }
                }
            }
        }

        // setTotal(acumulated)
        setTotalToPay(acumulatedToPay)
        setTotalSaved(totalSaved)
    }, [items])

    useEffect(() => {
        if (clientauth?.client) {
            dispatch(getClient(clientauth?.client))
        }
    }, [clientauth, dispatch])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (client && client.cards) {
            let defaultCard = client.cards?.find(c => c.favourite === true) || client.cards[0]
            if (defaultCard) {
                setSelectedCard(defaultCard._id)
            }
        }
    }, [client])

    useEffect(() => {
        const handlePaymentStatus = async () => {
            if (paymentStatus && paymentStatus !== 0) {
                // Solo actuar sobre el estado de éxito (3) desde el polling.
                // Los errores se gestionan únicamente cuando OperationKO envía el mensaje.
                if (paymentStatus === 3) {
                    clearInterval(window.checkOutPaymentStatusInterval)
                    setWaitingForPayment(false)
                    setIsPaying(false)

                    if (paymentData) {
                        dispatch(getClient(clientauth?.client))
                        dispatch({ type: 'PAYMENT_PAYMENT_DATA_RESET' })
                    }

                    // Esperamos 3 segundos para dar tiempo al webhook de PayComet
                    // de activar los tickets (status 0 → 1) antes de recargarlos
                    if (clientauth?.client) {
                        setTimeout(() => {
                            dispatch(getTicketsByClient(clientauth.client))
                        }, 3000)
                    }

                    if (clientauth) {
                        if (itemsPayment) {
                            dispatch({ type: 'PAYMENT_PAYMENT_REQUEST_RESET' })
                            dispatch(resetCart())
                            Swal.fire({
                                showConfirmButton: true,
                                icon: 'success',
                                text: t('cart.paymentSuccess')
                            })
                            sessionStorage.setItem('dataIncrono', JSON.stringify({...JSON.parse(sessionStorage.getItem('dataIncrono')), cartId: itemsPayment.cart._id, cartReference: itemsPayment.cart.cartReference}))
                            navigate('/' + t("url.marketplace.finishedCart"))
                        }
                    } else {
                        dispatch({ type: 'PAYMENT_PAYMENT_REQUEST_RESET' })
                        dispatch(resetCart())
                        Swal.fire({
                            showConfirmButton: true,
                            icon: 'success',
                            text: t('cart.paymentSuccess')
                        })
                        sessionStorage.setItem('dataIncrono', JSON.stringify({...JSON.parse(sessionStorage.getItem('dataIncrono')), cartId: publicPurchaseData.cart._id, cartReference: publicPurchaseData.cart.cartReference}))
                        dispatch({ type: "PAYMENT_START_PUBLIC_PURCHASE_RESET" })
                        setPaymentPersonData({
                            firstname: null,
                            lastname: null,
                            email: null
                        })
                        navigate('/' + t("url.marketplace.finishedCart"))
                    }
                }
                // Para cualquier estado no exitoso, solo reseteamos sin mostrar error.
                // El error se mostrará cuando OperationKO envíe el postMessage.
                dispatch({ type: 'PAYMENT_PAYMENT_STATUS_RESET' });
            }
        };

        handlePaymentStatus();
    }, [paymentStatus, paymentData, clientauth, itemsPayment, publicPurchaseData, dispatch, navigate, t, items]);

    useEffect(() => {
        if (itemsPayment?.payment === true) {
            clearInterval(window.checkOutPaymentStatusInterval)
            setWaitingForPayment(false)
            setIsPaying(false)
            dispatch({ type: 'PAYMENT_PAYMENT_STATUS_RESET' })
            dispatch({ type: 'PAYMENT_PAYMENT_REQUEST_RESET' })
            dispatch(resetCart())
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                text: t('cart.paymentSuccess')
            })
            sessionStorage.setItem('dataIncrono', JSON.stringify({...JSON.parse(sessionStorage.getItem('dataIncrono')), cartId: itemsPayment.cart._id, cartReference: itemsPayment.cart.cartReference}))
            navigate('/' + t("url.marketplace.finishedCart"))
        } else if (itemsPayment?.payment) {
            setWaitingForPayment(true)

            const intervalFn = () => {
                clearInterval(window.checkOutPaymentStatusInterval)
                setWaitingForPayment(false)
                setIsPaying(false)
                dispatch({ type: 'PAYMENT_PAYMENT_STATUS_RESET' })
            }

            window.checkOutPaymentStatusIntervalIndex = 0

            window.checkOutPaymentStatusInterval = setInterval(() => {
                window.checkOutPaymentStatusIntervalIndex++
                dispatch(getPaymentStatus(itemsPayment?.payment?._id))
                if (window.checkOutPaymentStatusIntervalIndex > 600) {
                    intervalFn()
                }
            }, 1000)
        }
    }, [itemsPayment, dispatch, t, navigate])

    return (
        <>
            <MenuMarketplace/>
            <Container className='market'>
                <div>
                    <Card className='border-0'>
                        <Card.Body>
                            <h2>{t("cart.finishCart")}</h2>
                            <hr className="mb-4"/>
                            {
                                items?.map((item, index) => (
                                    item.activity
                                    ?
                                        <CheckOutActivity item={item} key={index}/>
                                    :
                                        item.passType
                                        ?
                                            <CheckOutPassType key={index} item={item}/>
                                        :
                                            item.match
                                            ?
                                                <CheckOutTicket key={index} item={item}/>
                                            :
                                                item.court
                                                ?
                                                    <CheckOutReservation key={index} item={item}/>
                                                :
                                                    <Fragment key={index}/>
                                ))
                            }
                            <Row className='mt-3 align-items-end'>
                                {/* {
                                    needVerification &&
                                        <Col xs={12} className='mb-5'>
                                            <span className='text-muted'>* {t('cart.groupNeedVerificationText')}</span>
                                        </Col>
                                } */}
                                <Col xs={12}>
                                    <Col className='d-flex align-items-start fw-light'>
                                        <Form.Check className='float-left pe-3' type='checkbox' name='policy' onChange={(e) => setPolicy(e.target.checked)} checked={policy || false} />
                                        <p className="small mb-0">
                                            {t('users.policy1')}
                                            <a href="/politica-privacidad" className='link' target='_blank' rel="noreferrer"><u>{t('users.policy2')}</u></a>
                                            {t('users.policy3')}
                                            <a href="/devoluciones" className='link' target='_blank' rel="noreferrer"><u>{t('users.policy4')}</u></a>
                                        </p>
                                    </Col>
                                    <Col className='d-flex align-items-start fw-light'>
                                        <Form.Check className='float-left pe-3' type='checkbox' name='minors' onChange={(e) => setPolicyMinors(e.target.checked)} checked={policyMinors || false} />
                                        <div className="small mb-0">
                                            {t('users.policyMinors')}
                                        </div>
                                    </Col>
                                    <Col className='d-flex align-items-start fw-light'>
                                        <Form.Check className='float-left pe-3' type='checkbox' name='sendmarket' onChange={(e) => setPolicySendMarket(e.target.checked)} checked={policySendMarket || false} />
                                        <p className="small">
                                            {t('users.policySendMarket')}
                                        </p>
                                    </Col>
                                    <Col className='fw-light'>
                                        <p style={{fontSize:'11px'}}>
                                            {t('users.policyInfo')}
                                            <a href="/politica-privacidad" className='link' target='_blank' rel="noreferrer"><u>+Info</u></a>
                                        </p>
                                    </Col>
                                </Col>
                                <Col xs={12} md={8}>
                                    {/* <div className='d-flex align-items-end my-3'>
                                        <h2 className='me-3 mb-0'>{t('cart.total')}:</h2>
                                        <span>{total?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}€</span>
                                    </div> */}
                                    <h3 className='me-3 mb-0 font-single'>{t('cart.totalToPay')}:
                                        <span className='ps-3'>{totalToPay?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}€</span>
                                    </h3>


                                    {
                                        totalSaved && totalSaved > 0
                                        ?
                                            <h5 className='me-3 mb-0 font-single'>{t('cart.totalSaved')}:
                                                <span className='ps-3'>{totalSaved?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}€</span>
                                            </h5>
                                        :
                                            <></>
                                    }
                                </Col>
                                <Col xs={12} md={4}>
                                    <div className='d-grid'>
                                        <Button variant='primary' type='button' onClick={() => handlePayClick()} disabled={!policy}>
                                            {
                                                waitingForPayment
                                                    ?
                                                        <Loader className=''/>
                                                    :
                                                        t('cart.enroll')
                                            }
                                        </Button>
                                    </div>
                                </Col>
                                <hr className='my-1'/>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
            <Modal show={isPaying && !loading && !waitingForPayment} onHide={() => setIsPaying(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>{t('cart.paymentInformation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        loading || waitingForPayment
                            ?
                                <Loader/>
                            :
                                <Row>
                                    {
                                        client
                                        ?
                                            <>
                                                {
                                                    paymentData?.challengeUrl &&
                                                        <Col xs={12}>
                                                            <div className='mb-5'>{t('cart.needToRegisterCard')}</div>
                                                            <div className='d-grid'>
                                                                <a href={paymentData.challengeUrl} target='_blank' className='btn btn-primary' rel="noreferrer" onClick={handlePaymentLinkClick}>{t('cart.saveCard')}</a>
                                                            </div>
                                                        </Col>
                                                }
                                                {
                                                    client?.cards?.length > 0 &&
                                                        <Col xs={12}>
                                                        <div className='mb-5'>
                                                            <Form.Label htmlFor='selectedCard'>{t('cart.selectCard')}</Form.Label>
                                                            <FormSelect name='selectedCard' id='selectedCard' onChange={({target}) => setSelectedCard(target.value)} value={selectedCard || client.cards[0]._id}>
                                                                {
                                                                    client.cards.map(card => (
                                                                        <option key={card._id} value={card._id}>{card.name}</option>
                                                                    ))
                                                                }
                                                            </FormSelect>
                                                        </div>
                                                        <div className='d-grid mt-5'>
                                                            <Button type='button' variant='primary' onClick={saveCart}>{t('cart.pay')}</Button>
                                                        </div>
                                                        </Col>
                                                }
                                            </>
                                        :
                                            <>
                                                {
                                                    !publicPurchaseData &&
                                                    <>
                                                        <Col xs={12} md={6} className='pt-3'>
                                                            <Form.Group className='form-group'>
                                                                <Form.Control
                                                                    type='text'
                                                                    name='firstname'
                                                                    value={paymentPersonData.firstname || ''}
                                                                    className={paymentPersonData.firstname ? 'has-content form-control' : 'form-control'}
                                                                    onChange={handlePaymentPersonDataChange}
                                                                    disabled={false}
                                                                />
                                                                <Form.Label>{t('global.firstname')}</Form.Label>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs={12} md={6} className='pt-3'>
                                                            <Form.Group className='form-group'>
                                                                <Form.Control
                                                                    type='text'
                                                                    name='lastname'
                                                                    value={paymentPersonData.lastname || ''}
                                                                    className={paymentPersonData.lastname ? 'has-content form-control' : 'form-control'}
                                                                    onChange={handlePaymentPersonDataChange}
                                                                    disabled={false}
                                                                />
                                                                <Form.Label>{t('global.lastname')}</Form.Label>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs={12} className='pt-3'>
                                                            <Form.Group className='form-group'>
                                                                <Form.Control
                                                                    type='email'
                                                                    name='email'
                                                                    value={paymentPersonData.email || ''}
                                                                    className={paymentPersonData.email ? 'has-content form-control' : 'form-control'}
                                                                    onChange={handlePaymentPersonDataChange}
                                                                    disabled={false}
                                                                />
                                                                <Form.Label>{t('global.email')}</Form.Label>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                }
                                                {
                                                    publicPurchaseData
                                                    ?
                                                        <Col xs={12}>
                                                            <div className='d-grid'>
                                                                <a href={publicPurchaseData.challengeUrl} target='_blank' className='btn btn-primary' rel="noreferrer" onClick={handlePaymentLinkClick}>{t('cart.pay')}</a>
                                                            </div>
                                                        </Col>
                                                    :
                                                        <Col xs={12}>
                                                            <div className='d-grid mt-5'>
                                                                <Button type='button' variant='primary' onClick={handleStartPurchase}>{t('global.continue')}</Button>
                                                            </div>
                                                        </Col>
                                                }
                                            </>
                                    }
                                </Row>
                    }
                    {
                        error &&
                            <Alert variant='danger'>{ t('cart.' + error) }</Alert>
                    }
                </Modal.Body>
            </Modal>
            <FooterMarketplace />
        </>
    )
}